(function () {
  function initMarquee(root) {
    if (!root || root.dataset.zaoudBrandLogosInit === 'true') return;
    root.dataset.zaoudBrandLogosInit = 'true';

    var viewport = root.querySelector('.zaoud-brand-logos__viewport');
    var track = root.querySelector('.zaoud-brand-logos__track');
    if (!viewport || !track) return;

    var paused = false;
    var offset = 0;
    var lastTs = 0;
    var rafId = 0;
    var resumeTimer = 0;

    var dragging = false;
    var dragMoved = false;
    var pointerId = null;
    var startX = 0;
    var startOffset = 0;
    var lastDragX = 0;
    var dragVelocity = 0;
    var lastDragTs = 0;

    function loopWidth() {
      var group = track.querySelector('.zaoud-brand-logos__group');
      if (!group) return 0;
      return group.offsetWidth || group.scrollWidth || 0;
    }

    function stepSize() {
      var item = track.querySelector('.zaoud-brand-logos__item');
      if (!item) return 160;
      var styles = getComputedStyle(root);
      var gap = parseFloat(styles.getPropertyValue('--zaoud-brand-logos-gap')) || 24;
      return item.offsetWidth + gap;
    }

    function wrapOffset(value) {
      var half = loopWidth();
      if (half <= 1) return value;
      while (value < 0) value += half;
      while (value >= half) value -= half;
      return value;
    }

    function applyOffset() {
      track.style.transform = 'translate3d(' + -offset.toFixed(2) + 'px, 0, 0)';
    }

    function durationMs() {
      var raw = getComputedStyle(root).getPropertyValue('--zaoud-brand-logos-duration').trim();
      var seconds = parseFloat(raw);
      if (!seconds || seconds < 1) seconds = 30;
      return seconds * 1000;
    }

    function frame(ts) {
      if (!lastTs) lastTs = ts;
      var dt = Math.min(48, ts - lastTs);
      lastTs = ts;

      if (!paused && !dragging) {
        var half = loopWidth();
        if (half > 1) {
          offset += (half / durationMs()) * dt;
          if (offset >= half) offset -= half;
          applyOffset();
        }
      }

      rafId = window.requestAnimationFrame(frame);
    }

    function pause() {
      paused = true;
    }

    function resume() {
      paused = false;
      lastTs = 0;
    }

    function scheduleResume(delay) {
      clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(resume, delay || 2500);
    }

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      dragging = true;
      dragMoved = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      lastDragX = event.clientX;
      lastDragTs = event.timeStamp || performance.now();
      startOffset = offset;
      dragVelocity = 0;

      pause();
      clearTimeout(resumeTimer);
      viewport.classList.add('is-dragging');

      if (viewport.setPointerCapture) {
        try {
          viewport.setPointerCapture(pointerId);
        } catch (err) {
          /* ignore */
        }
      }
    }

    function onPointerMove(event) {
      if (!dragging || event.pointerId !== pointerId) return;

      var x = event.clientX;
      var delta = startX - x;
      if (Math.abs(delta) > 6) dragMoved = true;

      var now = event.timeStamp || performance.now();
      var frameDelta = x - lastDragX;
      var dt = Math.max(1, now - lastDragTs);
      dragVelocity = frameDelta / dt;
      lastDragX = x;
      lastDragTs = now;

      offset = wrapOffset(startOffset + delta);
      applyOffset();

      if (dragMoved && event.cancelable) event.preventDefault();
    }

    function onPointerUp(event) {
      if (!dragging || (pointerId != null && event.pointerId !== pointerId)) return;

      dragging = false;
      pointerId = null;
      viewport.classList.remove('is-dragging');

      if (dragMoved && Math.abs(dragVelocity) > 0.35) {
        var flick = dragVelocity > 0 ? -stepSize() * 0.35 : stepSize() * 0.35;
        offset = wrapOffset(offset + flick);
        applyOffset();
      }

      scheduleResume(2800);

      if (dragMoved) {
        var suppressClick = function (clickEvent) {
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
          viewport.removeEventListener('click', suppressClick, true);
        };
        viewport.addEventListener('click', suppressClick, true);
        window.setTimeout(function () {
          viewport.removeEventListener('click', suppressClick, true);
        }, 0);
      }

      dragMoved = false;
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove, { passive: false });
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);
    viewport.addEventListener('lostpointercapture', onPointerUp);

    viewport.addEventListener('mouseenter', function () {
      if (!dragging) pause();
    });
    viewport.addEventListener('mouseleave', function () {
      if (!dragging) resume();
    });
    viewport.addEventListener('focusin', pause);
    viewport.addEventListener('focusout', function (event) {
      if (!viewport.contains(event.relatedTarget) && !dragging) resume();
    });

    track.style.animation = 'none';
    track.style.willChange = 'transform';
    rafId = window.requestAnimationFrame(frame);

    root._zaoudBrandLogosDestroy = function () {
      window.cancelAnimationFrame(rafId);
      clearTimeout(resumeTimer);
      viewport.removeEventListener('pointerdown', onPointerDown);
      viewport.removeEventListener('pointermove', onPointerMove);
      viewport.removeEventListener('pointerup', onPointerUp);
      viewport.removeEventListener('pointercancel', onPointerUp);
      viewport.removeEventListener('lostpointercapture', onPointerUp);
    };
  }

  function boot() {
    document.querySelectorAll('[data-zaoud-brand-logos]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    var root =
      (section && section.matches && section.matches('[data-zaoud-brand-logos]') && section) ||
      (section && section.querySelector && section.querySelector('[data-zaoud-brand-logos]'));
    if (root) {
      if (typeof root._zaoudBrandLogosDestroy === 'function') {
        root._zaoudBrandLogosDestroy();
      }
      root.dataset.zaoudBrandLogosInit = '';
      initMarquee(root);
    }
  });
})();
